export const TrackerObjectiveValueTypes = {
  CHECKBOX: 'checkbox',
  CHECK_GRADE: 'check_grade',
  RUBRIC: 'rubric',
  RUBRIC_ZERO_TWO: 'rubric_zero_two',
  RUBRIC_ZERO_THREE: 'rubric_zero_three',
  RUBRIC_ZERO_FOUR: 'rubric_zero_four',
  NUMBER: 'number',
  TEXT: 'text'
};

export const AssignmentStatusOptions = {
  ASSIGNED: 'assigned',
  REVISE: 'revise',
  SUBMITTED: 'submitted',
  COMPLETE: 'complete'
};

export const AssignmentTaskValueTypes = {
  CHECKBOX: 'checkbox',
  CHECK_GRADE: 'check_grade',
  RUBRIC: 'rubric',
  RUBRIC_ZERO_TWO: 'rubric_zero_two',
  RUBRIC_ZERO_THREE: 'rubric_zero_three',
  RUBRIC_ZERO_FOUR: 'rubric_zero_four',
  NUMBER: 'number',
  TEXT: 'text'
};

export const AssignmentTaskValueTypeValueRange = {
  [AssignmentTaskValueTypes.RUBRIC]: [1, 2, 3, 4],
  [AssignmentTaskValueTypes.RUBRIC_ZERO_TWO]: [0, 1, 2],
  [AssignmentTaskValueTypes.RUBRIC_ZERO_THREE]: [0, 1, 2, 3],
  [AssignmentTaskValueTypes.RUBRIC_ZERO_FOUR]: [0, 1, 2, 3, 4]
};

export const AssignmentDepthOptions = {
  TASK: 1,
  CRITERIA: 2
};

export const MuiAutocompleteChangeReasons = {
  // For reference: https://material-ui.com/api/autocomplete/
  CREATE_OPTION: 'create-option',
  SELECT_OPTION: 'select-option',
  REMOVE_OPTION: 'remove-option',
  BLUR: 'blur',
  CLEAR: 'clear'
};

export const ActivityStreamVerbs = {
  ALL: 'all',
  GENERATED: 'generated',
  SCORED: 'scored',
  CREATED: 'created',
  UPDATED: 'updated',
  ASSIGNED: 'assigned',
  REVIEWED: 'reviewed',
  SUBMITTED: 'submitted',
  REVISED: 'revised'
};

export const ActivityStreamTimespanOptions = {
  WEEK: {
    key: 'week',
    value: 'week',
    text: 'Last 7 days'
  },
  MONTH: {
    key: 'month',
    value: 'month',
    text: 'Last 30 days'
  },
  YEAR: {
    key: 'year',
    value: 'year',
    text: 'This year'
  },
  LAST_YEAR: {
    key: 'last_year',
    value: 'last_year',
    text: 'Last year'
  }
};

export const Environments = {
  DEV: 'development',
  STAGING: 'staging',
  PROD: 'production',
  REVIEW: 'review'
};

export const ImgixDimensions = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};

export const SUBMITTED_STUDENT_PORTFOLIO_ASSIGNMENT_STATUS_FILTER_OPTION = {
  key: 'all_submitted',
  value: 'submitted',
  label: 'Submitted'
};

export const INCOMPLETE_STUDENT_PORTFOLIO_ASSIGNMENT_STATUS_FILTER_OPTION = {
  key: 'not_complete',
  value: 'incomplete',
  label: 'Incomplete'
};

export const ALL_STATUS_STUDENT_PORTFOLIO_ASSIGNMENT_STATUS_FILTER_OPTION = {
  key: 'all',
  value: 'all_statuses',
  label: 'All Statuses'
};

export const STUDENT_PORTFOLIO_ASSIGNMENT_STATUS_FILTER_OPTIONS = [
  SUBMITTED_STUDENT_PORTFOLIO_ASSIGNMENT_STATUS_FILTER_OPTION,
  INCOMPLETE_STUDENT_PORTFOLIO_ASSIGNMENT_STATUS_FILTER_OPTION,
  ALL_STATUS_STUDENT_PORTFOLIO_ASSIGNMENT_STATUS_FILTER_OPTION
];

export const STUDENT_PORTFOLIO_STANDARD_TABS = {
  MATH: 'MATH',
  ELA: 'ELA',
  NO_STANDARDS: 'NO_STANDARDS'
};

export const STANDARD_MSA = {
  MAJOR: 'm',
  SUPPORTING: 's',
  ADDITIONAL: 'a'
};

export const MSA_LABEL_MAPPING = {
  m: 'Major',
  s: 'Supporting',
  a: 'Additional'
};
